window.SylCot = (function(){
  var KEY = 'syl_cotizacion';

  function leer(){
    try{ return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch(e){ return []; }
  }

  function guardar(items){
    localStorage.setItem(KEY, JSON.stringify(items));
    window.dispatchEvent(new CustomEvent('syl:cotizacion:update', { detail: { items: items } }));
  }

  function agregar(producto){
    var items = leer();
    var encontrado = false;
    for(var i = 0; i < items.length; i++){
      if(String(items[i].id) === String(producto.id)){
        items[i].cantidad += (producto.cantidad || 1);
        encontrado = true;
        break;
      }
    }
    if(!encontrado){
      producto.cantidad = producto.cantidad || 1;
      items.push(producto);
    }
    guardar(items);
  }

  function quitar(id){
    guardar(leer().filter(function(i){ return String(i.id) !== String(id); }));
  }

  function actualizar(id, cantidad){
    if(cantidad < 1){ return quitar(id); }
    var items = leer();
    for(var i = 0; i < items.length; i++){
      if(String(items[i].id) === String(id)){
        items[i].cantidad = cantidad;
        break;
      }
    }
    guardar(items);
  }

  function vaciar(){ guardar([]); }

  function total(){
    return leer().reduce(function(s, i){ return s + i.cantidad; }, 0);
  }

  function estaEnLista(id){
    return leer().some(function(i){ return String(i.id) === String(id); });
  }

  function leerCantidadSelector(scope){
    var input = (scope || document).querySelector('.quantity__input');
    if(input){
      var val = parseInt(input.value, 10);
      if(!isNaN(val) && val > 0) return val;
    }
    return 1;
  }

  function buscarInputVariante(btn){
    var scope = btn.closest('product-info') || btn.closest('[data-section]') || document;
    return scope.querySelector('input[name="id"]') || document.querySelector('product-info input[name="id"]');
  }

  function idActualDeBoton(btn){
    var inputVariante = buscarInputVariante(btn);
    if(inputVariante && inputVariante.value){
      return String(inputVariante.value);
    }
    return String(btn.getAttribute('data-product-id'));
  }

  function nombreActualDeBoton(btn){
    var scope = btn.closest('product-info') || btn.closest('[data-section]') || document;
    var tituloEl = scope.querySelector('h1, .product__title h1');
    var base = tituloEl ? tituloEl.textContent.trim() : btn.getAttribute('data-product-nombre');
    var opcionActiva = scope.querySelector('variant-selects input:checked, variant-selects select option:checked, fieldset input:checked');
    if(opcionActiva && opcionActiva.value && opcionActiva.value.toLowerCase() !== 'default title'){
      return base + ' - ' + opcionActiva.value;
    }
    return base;
  }

  function actualizarVisualBoton(btn){
    var txtAgregar = btn.querySelector('.syl-prod-btn-txt-agregar');
    var txtOk = btn.querySelector('.syl-prod-btn-txt-ok');
    if(txtAgregar) txtAgregar.style.removeProperty('display');
    if(txtOk) txtOk.style.removeProperty('display');
    if(estaEnLista(idActualDeBoton(btn))){
      btn.classList.add('syl-agregado');
    } else {
      btn.classList.remove('syl-agregado');
    }
  }

  function manejarClick(e){
    var btn = e.currentTarget;
    var id = idActualDeBoton(btn);
    var scope = btn.closest('product-info') || btn.closest('[data-section]') || document;
    var cantidad = leerCantidadSelector(scope);

    // Leer precio del input de variante si existe
    var inputVariante = buscarInputVariante(btn);
    var precio = 0;
    if(inputVariante){
      var precioAttr = inputVariante.getAttribute('data-price') || inputVariante.closest('[data-price]') && inputVariante.closest('[data-price]').getAttribute('data-price');
      if(precioAttr) precio = parseInt(precioAttr) || 0;
    }

    agregar({
      id: id,
      nombre: nombreActualDeBoton(btn),
      imagen: btn.getAttribute('data-product-imagen'),
      url: btn.getAttribute('data-product-url'),
      cantidad: cantidad,
      precio: precio
    });

    var txtAgregar = btn.querySelector('.syl-prod-btn-txt-agregar');
    var txtOk = btn.querySelector('.syl-prod-btn-txt-ok');
    if(txtAgregar) txtAgregar.style.setProperty('display', 'none');
    if(txtOk) txtOk.style.setProperty('display', 'flex');

    setTimeout(function(){
      actualizarVisualBoton(btn);
    }, 2200);
  }

  function iniciarBoton(btn){
    if(btn.getAttribute('data-syl-init') === '1') return;
    btn.setAttribute('data-syl-init', '1');
    actualizarVisualBoton(btn);
    btn.addEventListener('click', manejarClick);
    window.addEventListener('syl:cotizacion:update', function(){
      actualizarVisualBoton(btn);
    });
    var ultimoId = idActualDeBoton(btn);
    function chequearCambio(){
      var idNuevo = idActualDeBoton(btn);
      if(idNuevo !== ultimoId){
        ultimoId = idNuevo;
        actualizarVisualBoton(btn);
      }
    }
    document.addEventListener('change', function(e){
      var t = e.target;
      if(t && (t.name === 'id' || t.closest('variant-selects') || t.closest('product-form') || t.classList.contains('product-form__input'))){
        setTimeout(chequearCambio, 60);
      }
    });
    document.addEventListener('click', function(e){
      var t = e.target;
      if(t && (t.closest('variant-selects') || t.closest('.product-form__input'))){
        setTimeout(chequearCambio, 60);
      }
    });
    var contenedor = btn.closest('product-info') || btn.closest('[data-section]');
    if(contenedor && window.MutationObserver){
      var obs = new MutationObserver(function(){ chequearCambio(); });
      obs.observe(contenedor, { childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'checked'] });
    }
    setInterval(chequearCambio, 500);
  }

  function iniciarBotones(){
    document.querySelectorAll('.syl-prod-btn').forEach(iniciarBoton);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', iniciarBotones);
  } else {
    iniciarBotones();
  }

  return { leer: leer, agregar: agregar, quitar: quitar, actualizar: actualizar, vaciar: vaciar, total: total };
})();

/* ============================================================
   SyL — Botones cantidad y agregar en tarjetas de catálogo
   ============================================================ */
(function(){

  // Botones + y -
  document.addEventListener('click', function(e){
    var esMas   = e.target.closest('[data-qty-mas]');
    var esMenos = e.target.closest('[data-qty-menos]');
    if(!esMas && !esMenos) return;
    e.preventDefault();
    e.stopPropagation();
    var wrap = e.target.closest('.syl-card-cot-qty');
    if(!wrap) return;
    var input = wrap.querySelector('.syl-card-cot-qty__input');
    if(!input) return;
    var val = parseInt(input.value) || 1;
    input.value = esMas ? Math.min(val + 1, 999) : Math.max(val - 1, 1);
  }, true);

  // Botón Agregar desde tarjeta de catálogo
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-syl-card-agregar]');
    if(!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var wrap = btn.closest('.syl-card-cot-wrap');
    var cantidad = 1;
    if(wrap){
      var input = wrap.querySelector('.syl-card-cot-qty__input');
      if(input) cantidad = Math.max(1, parseInt(input.value) || 1);
    }

    var id     = btn.getAttribute('data-id');
    var nombre = btn.getAttribute('data-titulo');
    var imagen = btn.getAttribute('data-imagen');
    var precio = parseInt(btn.getAttribute('data-precio')) || 0;
    var url    = btn.getAttribute('data-url') || window.location.pathname;

    if(!nombre || nombre === 'undefined'){
      var card = btn.closest('.card-wrapper');
      if(card){
        var tituloEl = card.querySelector('.card__heading a');
        if(tituloEl) nombre = tituloEl.textContent.trim();
      }
    }

    if(!id || !nombre) return;

    if(window.SylCot){
      window.SylCot.agregar({ id: id, nombre: nombre, imagen: imagen, url: url, cantidad: cantidad, precio: precio });
    }

    var textoEl = btn.querySelector('.syl-card-cot-btn__texto');
    var okEl    = btn.querySelector('.syl-card-cot-btn__ok');
    btn.classList.add('syl-agregado');
    if(textoEl) textoEl.style.display = 'none';
    if(okEl)    okEl.style.display = 'inline';
    setTimeout(function(){
      btn.classList.remove('syl-agregado');
      if(textoEl) textoEl.style.display = '';
      if(okEl)    okEl.style.display = 'none';
    }, 1500);

  }, true);

})();